module.exports = __webpack_public_path__ + "static/media/results-banner.12a4a7c9.png";